module.exports = __webpack_public_path__ + "static/media/keisan-logo.f6d1e68a.svg";